module.exports = __webpack_public_path__ + "static/media/banner22.7ea68486.png";